import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "down-icon" }
const _hoisted_2 = {
  key: 0,
  style: {"margin-left":"36px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")
  const _component_a_checkbox = _resolveComponent("a-checkbox")
  const _component_menu_list = _resolveComponent("menu-list", true)

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "menu-item",
      title: _ctx.node.name
    }, [
      _createVNode("span", _hoisted_1, [
        (_ctx.node.children && _ctx.node.children.length)
          ? (_openBlock(), _createBlock(_component_icon, {
              key: 0,
              class: { expanded: _ctx.node.expand },
              scale: "0.5",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleExpand(_ctx.node))),
              name: "drop_Icon"
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_a_checkbox, {
        class: "checkbox",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeChecked(_ctx.node))),
        indeterminate: _ctx.node.indeterminate,
        checked: _ctx.node.checked
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.node.name), 1)
        ]),
        _: 1
      }, 8, ["indeterminate", "checked"])
    ], 8, ["title"]),
    _createVNode(_Transition, { name: "md-fade-bottom" }, {
      default: _withCtx(() => [
        (_ctx.node.children && _ctx.node.children.length && _ctx.node.expand)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.node.children, (item, index) => {
                return (_openBlock(), _createBlock(_component_menu_list, {
                  key: index,
                  parentNode: _ctx.node,
                  node: item
                }, null, 8, ["parentNode", "node"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}